import React, { useState } from "react";
import UserService from "../Services/UserService";
import { message } from "antd";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    subject: "",
    messageContent: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      createdBy: "DOXADMIN",
      createdDate: new Date().toISOString().slice(0, 19).replace("T", " "),
      email: formData.email,
      mobileNumber: formData.mobileNumber,
      modifiedBy: "DOXADMIN",
      modifiedDate: new Date().toISOString().slice(0, 19).replace("T", " "),
      name: formData.name,
      messageContent: formData.messageContent,
      status: 1,
      subject: formData.subject,
    };

    try {
      await UserService.getInTouch(payload);
      setFormData({
        name: "",
        email: "",
        mobileNumber: "",
        subject: "",
        messageContent: "",
      });
      message.success("Message sent successfully");
    } catch (error) {
      console.error("Error sending message:", error);
      message.error("Failed to send message. Please try again.");
    }
  };

  return (
    <div className="contact h-auto">
      <div className="w-[50%] sm:w-[100%] mx-auto px-10">
        <h1 className="headingFont sm:text-center sm:text-[30px] md:text-[30px] lg:text-[30px] x:text-[40px] l:text-[40px] xl:text-[40px] 2xl:text-[50px] text-[#002f72]">
          Get In Touch With Us
        </h1>
        <form
          onSubmit={handleSubmit}
          className="w-[80%] sm:mx-auto xl:text-[14px] 2xl:text-[16px]"
        >
          <div className="flex sm:flex-col gap-x-5 mt-5">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="py-3 px-4 x:w-[350px] xl:w-[350px] 2xl:w-[470px] outline-none border-[1px] border-[#E1CAAE]"
            />

            <input
              type="text"
              name="email"
              placeholder="Email Id"
              value={formData.email}
              onChange={handleChange}
              className="py-3 px-4 sm:mt-5 xl:w-[350px] 2xl:w-[470px] outline-none border-[1px] border-[#E1CAAE]"
            />
          </div>
          <div className="flex sm:flex-col gap-x-5 mt-5">
            <input
              type="text"
              name="mobileNumber"
              placeholder="Phone"
              value={formData.mobileNumber}
              onChange={handleChange}
              className="py-3 px-4 xl:w-[350px] 2xl:w-[470px] outline-none border-[1px] border-[#E1CAAE]"
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              className="py-3 px-4 sm:mt-5 xl:w-[350px] 2xl:w-[470px] outline-none border-[1px] border-[#E1CAAE]"
            />
          </div>
          <div>
            <textarea
              name="messageContent"
              placeholder="Message"
              value={formData.messageContent}
              onChange={handleChange}
              className="py-3 px-4 w-full md:w-[450px] lg:w-[450px] x:w-[450px] xl:w-[510px] 2xl:w-[960px] mt-5 h-[100px] outline-none border-[1px] border-[#E1CAAE]"
            ></textarea>
          </div>

          <button className="uppercase sm:w-full bg-[#189FAA] lg:text-[14px] x:text-[14px] px-10 py-3 mt-5 rounded-full text-white hover:bg-[#338f97] transition-all duration-400 ease-in-out">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
